var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"visible":_vm.visible},on:{"close":function($event){_vm.visible = false}}},[_c('iframe',{ref:"iframe",staticClass:"Modal-iframe"})])}
var staticRenderFns = []

export { render, staticRenderFns }